export default {
  '<SOS>': 1,
  '<EOS>': 2,
  "\"switchLights('led#0==',": 3,
  "'#C2B078');\"": 4,
  "'#C6A664');\"": 5,
  "'#E5BE01');\"": 6,
  "'#CDA434');\"": 7,
  "'#A98307');\"": 8,
  "'#E4A010');\"": 9,
  "'#DC9D00');\"": 10,
  "'#8A6642');\"": 11,
  "'#C7B446');\"": 12,
  "'#EAE6CA');\"": 13,
  "'#E1CC4F');\"": 14,
  "'#E6D690');\"": 15,
  "'#EDFF21');\"": 16,
  "'#F5D033');\"": 17,
  "'#F8F32B');\"": 18,
  "'#9E9764');\"": 19,
  "'#999950');\"": 20,
  "'#F3DA0B');\"": 21,
  "'#FAD201');\"": 22,
  "'#AEA04B');\"": 23,
  "'#FFFF00');\"": 24,
  "'#9D9101');\"": 25,
  "'#F4A900');\"": 26,
  "'#D6AE01');\"": 27,
  "'#F3A505');\"": 28,
  "'#EFA94A');\"": 29,
  "'#6A5D4D');\"": 30,
  "'#705335');\"": 31,
  "'#F39F18');\"": 32,
  "'#ED760E');\"": 33,
  "'#C93C20');\"": 34,
  "'#CB2821');\"": 35,
  "'#FF7514');\"": 36,
  "'#F44611');\"": 37,
  "'#FF2301');\"": 38,
  "'#FFA420');\"": 39,
  "'#F75E25');\"": 40,
  "'#F54021');\"": 41,
  "'#D84B20');\"": 42,
  "'#EC7C26');\"": 43,
  "'#E55137');\"": 44,
  "'#C35831');\"": 45,
  "'#AF2B1E');\"": 46,
  "'#A52019');\"": 47,
  "'#A2231D');\"": 48,
  "'#9B111E');\"": 49,
  "'#75151E');\"": 50,
  "'#5E2129');\"": 51,
  "'#412227');\"": 52,
  "'#642424');\"": 53,
  "'#781F19');\"": 54,
  "'#C1876B');\"": 55,
  "'#A12312');\"": 56,
  "'#D36E70');\"": 57,
  "'#EA899A');\"": 58,
  "'#B32821');\"": 59,
  "'#E63244');\"": 60,
  "'#D53032');\"": 61,
  "'#CC0605');\"": 62,
  "'#D95030');\"": 63,
  "'#F80000');\"": 64,
  "'#FE0000');\"": 65,
  "'#C51D34');\"": 66,
  "'#CB3234');\"": 67,
  "'#B32428');\"": 68,
  "'#721422');\"": 69,
  "'#B44C43');\"": 70,
  "'#6D3F5B');\"": 71,
  "'#922B3E');\"": 72,
  "'#DE4C8A');\"": 73,
  "'#641C34');\"": 74,
  "'#6C4675');\"": 75,
  "'#A03472');\"": 76,
  "'#4A192C');\"": 77,
  "'#924E7D');\"": 78,
  "'#A18594');\"": 79,
  "'#CF3476');\"": 80,
  "'#8673A1');\"": 81,
  "'#6C6874');\"": 82,
  "'#354D73');\"": 83,
  "'#1F3438');\"": 84,
  "'#20214F');\"": 85,
  "'#1D1E33');\"": 86,
  "'#18171C');\"": 87,
  "'#1E2460');\"": 88,
  "'#3E5F8A');\"": 89,
  "'#26252D');\"": 90,
  "'#025669');\"": 91,
  "'#0E294B');\"": 92,
  "'#231A24');\"": 93,
  "'#3B83BD');\"": 94,
  "'#1E213D');\"": 95,
  "'#606E8C');\"": 96,
  "'#2271B3');\"": 97,
  "'#063971');\"": 98,
  "'#3F888F');\"": 99,
  "'#1B5583');\"": 100,
  "'#1D334A');\"": 101,
  "'#256D7B');\"": 102,
  "'#252850');\"": 103,
  "'#49678D');\"": 104,
  "'#5D9B9B');\"": 105,
  "'#2A6478');\"": 106,
  "'#102C54');\"": 107,
  "'#316650');\"": 108,
  "'#287233');\"": 109,
  "'#2D572C');\"": 110,
  "'#424632');\"": 111,
  "'#1F3A3D');\"": 112,
  "'#2F4538');\"": 113,
  "'#3E3B32');\"": 114,
  "'#343B29');\"": 115,
  "'#39352A');\"": 116,
  "'#31372B');\"": 117,
  "'#35682D');\"": 118,
  "'#587246');\"": 119,
  "'#343E40');\"": 120,
  "'#6C7156');\"": 121,
  "'#47402E');\"": 122,
  "'#3B3C36');\"": 123,
  "'#1E5945');\"": 124,
  "'#4C9141');\"": 125,
  "'#57A639');\"": 126,
  "'#BDECB6');\"": 127,
  "'#2E3A23');\"": 128,
  "'#89AC76');\"": 129,
  "'#25221B');\"": 130,
  "'#308446');\"": 131,
  "'#3D642D');\"": 132,
  "'#015D52');\"": 133,
  "'#84C3BE');\"": 134,
  "'#2C5545');\"": 135,
  "'#20603D');\"": 136,
  "'#317F43');\"": 137,
  "'#497E76');\"": 138,
  "'#7FB5B5');\"": 139,
  "'#1C542D');\"": 140,
  "'#193737');\"": 141,
  "'#008F39');\"": 142,
  "'#00BB2D');\"": 143,
  "'#78858B');\"": 144,
  "'#8A9597');\"": 145,
  "'#7E7B52');\"": 146,
  "'#6C7059');\"": 147,
  "'#969992');\"": 148,
  "'#646B63');\"": 149,
  "'#6D6552');\"": 150,
  "'#6A5F31');\"": 151,
  "'#4D5645');\"": 152,
  "'#4C514A');\"": 153,
  "'#434B4D');\"": 154,
  "'#4E5754');\"": 155,
  "'#464531');\"": 156,
  "'#434750');\"": 157,
  "'#293133');\"": 158,
  "'#23282B');\"": 159,
  "'#332F2C');\"": 160,
  "'#686C5E');\"": 161,
  "'#474A51');\"": 162,
  "'#2F353B');\"": 163,
  "'#8B8C7A');\"": 164,
  "'#474B4E');\"": 165,
  "'#B8B799');\"": 166,
  "'#7D8471');\"": 167,
  "'#8F8B66');\"": 168,
  "'#CBD0CC');\"": 169,
  "'#7F7679');\"": 170,
  "'#7D7F7D');\"": 171,
  "'#B5B8B1');\"": 172,
  "'#6C6960');\"": 173,
  "'#9DA1AA');\"": 174,
  "'#8D948D');\"": 175,
  "'#4E5452');\"": 176,
  "'#CAC4B0');\"": 177,
  "'#909090');\"": 178,
  "'#82898F');\"": 179,
  "'#D0D0D0');\"": 180,
  "'#898176');\"": 181,
  "'#826C34');\"": 182,
  "'#955F20');\"": 183,
  "'#6C3B2A');\"": 184,
  "'#734222');\"": 185,
  "'#8E402A');\"": 186,
  "'#59351F');\"": 187,
  "'#6F4F28');\"": 188,
  "'#5B3A29');\"": 189,
  "'#592321');\"": 190,
  "'#382C1E');\"": 191,
  "'#633A34');\"": 192,
  "'#4C2F27');\"": 193,
  "'#45322E');\"": 194,
  "'#403A3A');\"": 195,
  "'#212121');\"": 196,
  "'#A65E2E');\"": 197,
  "'#79553D');\"": 198,
  "'#755C48');\"": 199,
  "'#4E3B31');\"": 200,
  "'#763C28');\"": 201,
  "'#FDF4E3');\"": 202,
  "'#E7EBDA');\"": 203,
  "'#F4F4F4');\"": 204,
  "'#282828');\"": 205,
  "'#0A0A0A');\"": 206,
  "'#A5A5A5');\"": 207,
  "'#8F8F8F');\"": 208,
  "'#FFFFFF');\"": 209,
  "'#1C1C1C');\"": 210,
  "'#F6F6F6');\"": 211,
  "'#1E1E1E');\"": 212,
  "'#CFD3CD');\"": 213,
  "'#9C9C9C');\"": 214,
  "'#828282');\"": 215,
  "'#BEBD7F');\"": 216,
  "'#BEBD7F');": 217,
  "'#C2B078');": 218,
  "'#C6A664');": 219,
  "'#E5BE01');": 220,
  "'#CDA434');": 221,
  "'#A98307');": 222,
  "'#E4A010');": 223,
  "'#DC9D00');": 224,
  "'#8A6642');": 225,
  "'#C7B446');": 226,
  "'#EAE6CA');": 227,
  "'#E1CC4F');": 228,
  "'#E6D690');": 229,
  "'#EDFF21');": 230,
  "'#F5D033');": 231,
  "'#F8F32B');": 232,
  "'#9E9764');": 233,
  "'#999950');": 234,
  "'#F3DA0B');": 235,
  "'#FAD201');": 236,
  "'#AEA04B');": 237,
  "'#FFFF00');": 238,
  "'#9D9101');": 239,
  "'#F4A900');": 240,
  "'#D6AE01');": 241,
  "'#F3A505');": 242,
  "'#EFA94A');": 243,
  "'#6A5D4D');": 244,
  "'#705335');": 245,
  "'#F39F18');": 246,
  "'#ED760E');": 247,
  "'#C93C20');": 248,
  "'#CB2821');": 249,
  "'#FF7514');": 250,
  "'#F44611');": 251,
  "'#FF2301');": 252,
  "'#FFA420');": 253,
  "'#F75E25');": 254,
  "'#F54021');": 255,
  "'#D84B20');": 256,
  "'#EC7C26');": 257,
  "'#E55137');": 258,
  "'#C35831');": 259,
  "'#AF2B1E');": 260,
  "'#A52019');": 261,
  "'#A2231D');": 262,
  "'#9B111E');": 263,
  "'#75151E');": 264,
  "'#5E2129');": 265,
  "'#412227');": 266,
  "'#642424');": 267,
  "'#781F19');": 268,
  "'#C1876B');": 269,
  "'#A12312');": 270,
  "'#D36E70');": 271,
  "'#EA899A');": 272,
  "'#B32821');": 273,
  "'#E63244');": 274,
  "'#D53032');": 275,
  "'#CC0605');": 276,
  "'#D95030');": 277,
  "'#F80000');": 278,
  "'#FE0000');": 279,
  "'#C51D34');": 280,
  "'#CB3234');": 281,
  "'#B32428');": 282,
  "'#721422');": 283,
  "'#B44C43');": 284,
  "'#6D3F5B');": 285,
  "'#922B3E');": 286,
  "'#DE4C8A');": 287,
  "'#641C34');": 288,
  "'#6C4675');": 289,
  "'#A03472');": 290,
  "'#4A192C');": 291,
  "'#924E7D');": 292,
  "'#A18594');": 293,
  "'#CF3476');": 294,
  "'#8673A1');": 295,
  "'#6C6874');": 296,
  "'#354D73');": 297,
  "'#1F3438');": 298,
  "'#20214F');": 299,
  "'#1D1E33');": 300,
  "'#18171C');": 301,
  "'#1E2460');": 302,
  "'#3E5F8A');": 303,
  "'#26252D');": 304,
  "'#025669');": 305,
  "'#0E294B');": 306,
  "'#231A24');": 307,
  "'#3B83BD');": 308,
  "'#1E213D');": 309,
  "'#606E8C');": 310,
  "'#2271B3');": 311,
  "'#063971');": 312,
  "'#3F888F');": 313,
  "'#1B5583');": 314,
  "'#1D334A');": 315,
  "'#256D7B');": 316,
  "'#252850');": 317,
  "'#49678D');": 318,
  "'#5D9B9B');": 319,
  "'#2A6478');": 320,
  "'#102C54');": 321,
  "'#316650');": 322,
  "'#287233');": 323,
  "'#2D572C');": 324,
  "'#424632');": 325,
  "'#1F3A3D');": 326,
  "'#2F4538');": 327,
  "'#3E3B32');": 328,
  "'#343B29');": 329,
  "'#39352A');": 330,
  "'#31372B');": 331,
  "'#35682D');": 332,
  "'#587246');": 333,
  "'#343E40');": 334,
  "'#6C7156');": 335,
  "'#47402E');": 336,
  "'#3B3C36');": 337,
  "'#1E5945');": 338,
  "'#4C9141');": 339,
  "'#57A639');": 340,
  "'#BDECB6');": 341,
  "'#2E3A23');": 342,
  "'#89AC76');": 343,
  "'#25221B');": 344,
  "'#308446');": 345,
  "'#3D642D');": 346,
  "'#015D52');": 347,
  "'#84C3BE');": 348,
  "'#2C5545');": 349,
  "'#20603D');": 350,
  "'#317F43');": 351,
  "'#497E76');": 352,
  "'#7FB5B5');": 353,
  "'#1C542D');": 354,
  "'#193737');": 355,
  "'#008F39');": 356,
  "'#00BB2D');": 357,
  "'#78858B');": 358,
  "'#8A9597');": 359,
  "'#7E7B52');": 360,
  "'#6C7059');": 361,
  "'#969992');": 362,
  "'#646B63');": 363,
  "'#6D6552');": 364,
  "'#6A5F31');": 365,
  "'#4D5645');": 366,
  "'#4C514A');": 367,
  "'#434B4D');": 368,
  "'#4E5754');": 369,
  "'#464531');": 370,
  "'#434750');": 371,
  "'#293133');": 372,
  "'#23282B');": 373,
  "'#332F2C');": 374,
  "'#686C5E');": 375,
  "'#474A51');": 376,
  "'#2F353B');": 377,
  "'#8B8C7A');": 378,
  "'#474B4E');": 379,
  "'#B8B799');": 380,
  "'#7D8471');": 381,
  "'#8F8B66');": 382,
  "'#CBD0CC');": 383,
  "'#7F7679');": 384,
  "'#7D7F7D');": 385,
  "'#B5B8B1');": 386,
  "'#6C6960');": 387,
  "'#9DA1AA');": 388,
  "'#8D948D');": 389,
  "'#4E5452');": 390,
  "'#CAC4B0');": 391,
  "'#909090');": 392,
  "'#82898F');": 393,
  "'#D0D0D0');": 394,
  "'#898176');": 395,
  "'#826C34');": 396,
  "'#955F20');": 397,
  "'#6C3B2A');": 398,
  "'#734222');": 399,
  "'#8E402A');": 400,
  "'#59351F');": 401,
  "'#6F4F28');": 402,
  "'#5B3A29');": 403,
  "'#592321');": 404,
  "'#382C1E');": 405,
  "'#633A34');": 406,
  "'#4C2F27');": 407,
  "'#45322E');": 408,
  "'#403A3A');": 409,
  "'#212121');": 410,
  "'#A65E2E');": 411,
  "'#79553D');": 412,
  "'#755C48');": 413,
  "'#4E3B31');": 414,
  "'#763C28');": 415,
  "'#FDF4E3');": 416,
  "'#E7EBDA');": 417,
  "'#F4F4F4');": 418,
  "'#282828');": 419,
  "'#0A0A0A');": 420,
  "'#A5A5A5');": 421,
  "'#8F8F8F');": 422,
  "'#FFFFFF');": 423,
  "'#1C1C1C');": 424,
  "'#F6F6F6');": 425,
  "'#1E1E1E');": 426,
  "'#CFD3CD');": 427,
  "'#9C9C9C');": 428,
  "'#828282');": 429,
  '<UNK>': 0,
};
